import { makeCRUDSlice } from '@redux/crudCreator';
import { MODEL_NAME, rolePermissionsActions } from './actions';

const slice = makeCRUDSlice(MODEL_NAME, rolePermissionsActions);

export default slice.reducer;
